import { Reveal } from "@/components/Reveal";

export const Location = ({ hideHeader = false }) => (
  <section id="location" className={`${hideHeader ? "py-12 md:py-20" : "py-24 md:py-32"} bg-[hsl(var(--marble))]/60`}>
    <div className="container-editorial">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          {!hideHeader && (
            <>
              <div className="eyebrow-rule">Location</div>
              <h2 className="editorial-heading text-3xl md:text-4xl lg:text-[52px]">
                Right in the heart<br />
                <em>of Rarotonga.</em>
              </h2>
            </>
          )}
          {!hideHeader && (
            <p className="mt-6 text-[hsl(var(--muted-foreground))] max-w-md">
              Ata House sits on the main road beside <span className="font-serif-italic">Muri Beach</span> — Rarotonga&apos;s most
              beloved stretch of lagoon. A short walk takes you to crystal-clear water,
              cafés, restaurants, and the island&apos;s gentlest snorkelling spots.
              The bus stop is just 20 metres away with an hourly service around the island.
            </p>
          )}

          <dl className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { k: "To airport", v: "≈ 25 min by car" },
              { k: "To nearest beach", v: "≈ 3 min walk" },
              { k: "Bus stop", v: "20 m from door" },
            ].map((row) => (
              <div key={row.k} className="border-t border-[hsl(var(--border))] pt-4">
                <dt className="tracking-eyebrow text-[10px] text-[hsl(var(--muted-foreground))] mb-2">
                  {row.k}
                </dt>
                <dd className="font-display text-xl">{row.v}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-6 text-xs italic text-[hsl(var(--muted-foreground))]">
            Exact address shared on confirmed booking.
          </p>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-7">
          <div className="relative aspect-[4/3] md:aspect-[16/11] rounded-2xl overflow-hidden border border-[hsl(var(--border))] shadow-sm bg-white">
            <iframe
              title="Muri Beach, Rarotonga map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-159.840%2C-21.285%2C-159.710%2C-21.190&amp;layer=mapnik&amp;marker=-21.2455%2C-159.7283"
              className="absolute inset-0 w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
